import { sagas as auth } from './auth'
import { sagas as landing } from './landing'
import { sagas as newsletter } from './newsletter'

export default {
  ...auth, ...landing, ...newsletter,
}
